export const NAME = 'manage-password';

export const RESET_PASSWORD_IN_PROFILE = 0;
export const RESET_PASSWORD_IN_USERS = 1;
